import script from "./PaperView.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaperView.vue?vue&type=script&setup=true&lang=ts"

import "./PaperView.vue?vue&type=style&index=0&id=dd756a04&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd756a04"]])

export default __exports__